import bottomArrow from "../../assets/icons/bottom-arrow.png";
import { Search } from "lucide-react";
import { useState, useRef, useLayoutEffect, useEffect } from "react";

// زیر‌کامپوننت دراپ‌دان جستجو‌پذیر
const SearchableDropdown = ({
  label,
  options = [],
  value,
  onChange,
  isOpen,
  onToggle,
}) => {
  const [search, setSearch] = useState("");

  const buttonRef = useRef(null);
  const [position, setPosition] = useState(null);

  useLayoutEffect(() => {
    if (!isOpen || !buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    setPosition({
      top: rect.bottom + 8,
      left: rect.left,
      width: rect.width,
    });
  }, [isOpen]);

  const query = search.toLowerCase();

  const filteredOptions = options.filter((item) =>
    (item?.title || "").toLowerCase().includes(query),
  );

  const selectedOption = options.find((item) => item.id === value);
  const displayValue = selectedOption?.title || "";

  useEffect(() => {
    if (!isOpen) return;

    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      window.scrollTo(0, scrollY);
    };
  }, [isOpen]);

  return (
    <div className="relative min-w-[100px] lg:min-w-0 shrink-0 scrollbar-hide">
      {/* Desktop Label */}
      <label className="hidden lg:block mb-1.5 text-sm font-medium text-gray-700">
        {label}
      </label>

      <button
        ref={buttonRef}
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        className="
          flex
          items-center
          justify-between

          h-9
          lg:h-11

          w-full

          rounded-full
          lg:rounded-xl

          border
          border-gray-200

          bg-white

          px-3

          text-[11.5px]
          lg:text-[13px]

          transition-all

          hover:border-[#49D1CD]
        "
      >
        <span
          className={`hidden lg:flex truncate flex-1 text-right ${
            displayValue ? "text-gray-800" : "text-gray-400"
          }`}
        >
          {displayValue || `${label} را انتخاب کنید`}
        </span>
        <span
          className={`flex lg:hidden truncate flex-1 text-right ${
            displayValue ? "text-gray-800" : "text-gray-400"
          }`}
        >
          {displayValue || label}
        </span>
        <img
          src={bottomArrow}
          alt=""
          className={`w-2 transition-transform duration-300 mr-1 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && position && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-[9998]"
            onClick={() => {
              setSearch("");
              onToggle();
            }}
          />

          {/* Dropdown */}
          <div
            style={{
              position: "fixed",
              top: position.top,
              left: position.left,
              width: position.width,
              zIndex: 9999,
            }}
            className="
              rounded-xl
              border
              border-gray-200
              bg-white
              p-2
              shadow-xl
            "
          >
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={`جستجو در ${label}`}
              className="
                mb-2
                h-8
                md:h-10
                w-full

                rounded-lg
                border
                border-gray-200

                px-3

                text-[11px]
                md:text-[12px]
                outline-none

                focus:border-[#49D1CD]
              "
            />

            <div className="max-h-[260px] overflow-y-auto">
              <button
                type="button"
                onClick={() => {
                  onChange("");
                  setSearch("");
                  onToggle();
                }}
                className="
                  mb-1
                  w-full

                  rounded-lg

                  px-3
                  py-0.5

                  text-right
                  text-[10px]
lg:text-[12px]
                  text-gray-600

                  hover:bg-gray-50
                "
              >
                همه
              </button>

              {filteredOptions.length ? (
                filteredOptions.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    onClick={() => {
                      onChange(item.id);
                      setSearch("");
                      onToggle();
                    }}
                    className={`w-full rounded-lg px-3 py-1 mb-1 text-right text-[10px] lg:text-[12px]
 transition ${
   value === item.id
     ? "bg-[#49D1CD]/10 text-[#49D1CD]"
     : "text-gray-700 hover:bg-gray-50"
 }`}
                  >
                    {item.title}
                  </button>
                ))
              ) : (
                <div className="py-3 text-center text-sm text-gray-400">
                  موردی پیدا نشد
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
// کامپوننت اصلی فیلتر
const MedicalCentersFilter = ({
  filters,
  setFilters,
  options,
  isAnyFilterActive,
  onReset,
  openDropdown,
  setOpenDropdown,
}) => {
  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleToggle = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <div
      className=" w-full "
      onClick={(e) => e.stopPropagation()}
    >
      {/* یک باکس سفید برای موبایل و دسکتاپ */}
      <div className="rounded-2xl bg-white p-4 shadow-sm mb-1">
        {/* سرچ */}
        <div className="relative w-full">
          <Search
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[#49D1CD]"
            size={18}
            strokeWidth={3}
          />

          <input
            type="text"
            value={filters.search}
            onChange={(e) => handleChange("search", e.target.value)}
            placeholder="جستجوی مرکز درمانی ..."
            className="
              h-12
              w-full
              rounded-xl
              border
              border-[#49D1CD]/50
              pr-10
              px-3
              text-sm
              outline-none
              transition-all
              placeholder:text-[13px]
              placeholder:text-gray-400
              focus:border-[#49D1CD]
            "
          />
        </div>

        {/* ===========================
            MOBILE FILTERS
        ============================ */}

        <div
          className="
            lg:hidden
            mt-3
            -mx-4
            px-4
            overflow-x-auto
            scrollbar-hide
          "
        >
          <div
            className="
              flex
              items-start
              gap-1
              lg:gap-2
              min-w-max
              pb-1
            "
          >
            {/* شهر */}
            <SearchableDropdown
              label="شهر"
              options={options.cities}
              value={filters.city_id}
              isOpen={openDropdown === "city"}
              onToggle={() => handleToggle("city")}
              onChange={(val) => handleChange("city_id", val)}
            />

            {/* دسته بندی */}
            <SearchableDropdown
              label="دسته بندی"
              options={options.categories}
              value={filters.category_id}
              isOpen={openDropdown === "category"}
              onToggle={() => handleToggle("category")}
              onChange={(val) => handleChange("category_id", val)}
            />

            {/* گروه درمانی */}
            <SearchableDropdown
              label="گروه درمانی"
              options={options.treatmentGroups}
              value={filters.group_id}
              isOpen={openDropdown === "treatment"}
              onToggle={() => handleToggle("treatment")}
              onChange={(val) => handleChange("group_id", val)}
            />

            {/* بیمه */}
            <SearchableDropdown
              label="بیمه"
              options={options.insurances}
              value={filters.insurance_id}
              isOpen={openDropdown === "insurance"}
              onToggle={() => handleToggle("insurance")}
              onChange={(val) => handleChange("insurance_id", val)}
            />
          </div>
        </div>

        {/* ===========================
            DESKTOP FILTERS
        ============================ */}

        <div className="hidden lg:block mt-4">
          <div className="space-y-6">
            {/* شهر */}
            <SearchableDropdown
              label="شهر"
              options={options.cities}
              value={filters.city_id}
              isOpen={openDropdown === "city"}
              onToggle={() => handleToggle("city")}
              onChange={(val) => handleChange("city_id", val)}
            />

            {/* دسته بندی */}
            <SearchableDropdown
              label="دسته بندی"
              options={options.categories}
              value={filters.category_id}
              isOpen={openDropdown === "category"}
              onToggle={() => handleToggle("category")}
              onChange={(val) => handleChange("category_id", val)}
            />

            {/* گروه درمانی */}
            <SearchableDropdown
              label="گروه درمانی"
              options={options.treatmentGroups}
              value={filters.group_id}
              isOpen={openDropdown === "treatment"}
              onToggle={() => handleToggle("treatment")}
              onChange={(val) => handleChange("group_id", val)}
            />

            {/* بیمه */}
            <SearchableDropdown
              label="بیمه"
              options={options.insurances}
              value={filters.insurance_id}
              isOpen={openDropdown === "insurance"}
              onToggle={() => handleToggle("insurance")}
              onChange={(val) => handleChange("insurance_id", val)}
            />
            {/* دکمه پاک کردن فیلترها */}
            {isAnyFilterActive && (
              <div className="mt-3 flex justify-center pb-1 hidden lg:flex">
                <button
                  onClick={onReset}
                  className="text-xs font-medium text-[#B00EB1] transition hover:opacity-80"
                >
                  پاک کردن همه فیلترها
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicalCentersFilter;
